module.exports = __webpack_public_path__ + "img/step_six.981e4c38.png";